// Global feature flags for incremental rollouts
export const FEATURES = {
  // Gate all multi-year planning logic and UI
  MULTI_YEAR_PLANNING: true,
  // Gate the new banner-driven panel navigation
  PANEL_NAV: true,
  // Temporarily hide the Items planning tab
  ITEMS_TAB: false,
  // Gate the priorities onboarding quiz
  QUIZ_ONBOARDING: false,
};

